export const images = [
    {
      id: '01',
      src: '/barbershop 03.jpg',
      alt: 'Lofts on 34th',
    },
    // {
    //   id: '02',
    //   src: '/shulsen-lane-2.jpg',
    //   alt: 'Shulsen Lane',
    // },
    {
      id: '03',
      src: '/barbershop 04.jpg',
      alt: 'Lofts on 34th',
    },
    {
      id: '04',
      src: '/barbershop 01.jpg',
      alt: 'Lofts on 34th',
    },
    
    {
        id: '06',
        src: '/barbershop 02.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/barbershop 05.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/barbershop 06.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/barbershop 09.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/barbershop 15.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/barbershop 16.jpg',
        alt: 'Lofts on 34th',
      },
      {
        id: '07',
        src: '/barbershop 17.jpg',
        alt: 'Lofts on 34th',
      },
     
     
    //   {
    //     id: '05',
    //     src: '/DesertSage (5).jpg',
    //     alt: 'Shulsen Lane',
    //   },
    // {
    //   id: '06',
    //   src: '/Alpine_Flats_Theater_Room.jpg',
    //   alt: 'Revive Apartments',
    // },
   
  ]